<template>
  <BulkActionMenu
    :actions="actions"
    :disabled="selectedItems && selectedItems.length !== 2"
  >
    <template v-slot:compare="{ hide }">
      <Compare :selected-items="selectedItems" @trigger="hide" />
    </template>
  </BulkActionMenu>
</template>

<script>
import BulkActionMenu from '@components/bulk-action-menu'
import Compare from './action-menu-items/compare'

export default {
  name: 'BulkActions',
  components: {
    BulkActionMenu,
    Compare,
  },
  props: {
    items: { type: Array, required: true },
    selectedItemIds: { type: Array, required: true },
    toggleSelectAll: { type: Function, required: true },
    refreshList: { type: Function, required: true },
  },
  data() {
    let actions = ['compare']
    this.actions = actions
    return {}
  },
  computed: {
    selectedItems() {
      return this.selectedItemIds.map((id) =>
        (this.items || []).find((i) => i.id === id)
      )
    },
  },
  methods: {
    unselectAll() {
      this.toggleSelectAll()
    },
  },
}
</script>
